/**
 * Reports store JSON in reports.file_url. Legacy rows may hold other strings.
 */
export function parseReportPayload(fileUrl) {
  if (fileUrl == null || fileUrl === '') {
    throw new Error('Données du rapport manquantes');
  }
  if (typeof fileUrl === 'object') {
    return fileUrl;
  }
  const trimmed = String(fileUrl).trim();
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    return JSON.parse(trimmed);
  }
  throw new Error('Format de rapport obsolète — régénérez le rapport');
}
